<pm-dialog
  dialogTitle="REPORTING.IMPORT_DIALOG.TITLE"
  [secondaryCtaButtonConfig]="buttonConfigs().cancelConfig"
  [primaryCtaButtonConfig]="buttonConfigs().submitConfig"
>
  <p class="text-sm text-gray-600 mb-6">
    {{ 'REPORTING.IMPORT_DIALOG.DESCRIPTION' | translate }}
  </p>

  <pm-form-field [label]="'REPORTING.IMPORT_DIALOG.SELECT_VERSION' | translate">
    <pm-form-input-select
      [data]="versionOptions()"
      [sortByKey]="'createdAt'"
      [sortDirection]="'desc'"
      [ngModel]="selectedVersionId()"
      (ngModelChange)="selectedVersionId.set($event)"
    />
  </pm-form-field>
</pm-dialog>
